
import { inject, reactive, ref, provide, computed, watchEffect} from 'vue';
import Card from '@/components/content/views/card/card.vue';
import FormattingService from '@/services/formatting.service';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faBoxArchive, faBookmark, faInfo, faMedal } from '@fortawesome/free-solid-svg-icons'
import Tooltip from '@/components/content/views/tooltip/tooltip.vue';
import ProgressBar from '@/components/content/blocks/progress-bar/progress-bar.vue';

library.add(faBookmark)
library.add(faBoxArchive)
library.add(faInfo)
library.add(faMedal);

export default {
  name: 'Course',
  props: {
    user: {
      type: Object,
      required: false
    },
    item: {
      type: Object,
      required: true,
    },
    reload: {
      type: Boolean,
      default: false,
    },
    trackId: {
      type: Number,
      required: false,
    },
    trackOrderNumber: {
      type: Number,
      required: false,
    }
  },
  components: {
    FontAwesomeIcon,
    Card,
    Tooltip,
    ProgressBar,
  },
  setup(props, {emit} ) {

    const config = inject('config');
    const authProvider = inject('authProvider');
    const memberProvider = inject('memberProvider');
    const collectionsProvider = inject('collectionsProvider');

    const state = reactive({
      member: computed(() => props.user),
      item: computed(() => props.item),
      isBookmarked: computed(() => state.member.bookmarks ? state.member.bookmarks.includes(state.item.id): false),
      isArchived: computed(() => state.member.archives ? state.member.archives.includes(state.item.id) : false),
      imageUrl: computed(() => {
        if(!state.item.cover && !state.item.images) return '';
        if(state.item.cover) {
          if(state.item.cover['480w']) return state.item.cover['480w'];
          if(state.item.cover['768w']) return state.item.cover['768w'];
        }
        if(state.item.images['480w']) return state.item.images['480w'];
        if(state.item.images['600w']) return state.item.images['600w'];
        if(state.item.images['768w']) return state.item.images['768w'];
        return state.item.images.full;
      }),
      status: computed(() => {
        if(state.member) {
          let foundCourse = state.member.content.find((course) => {
            return state.item.id === course.id;
          })
          if(foundCourse) {
            if(foundCourse.completed) {
              return 'completed';
            }
            if(foundCourse.started && !foundCourse.completed) {
              return 'started';
            }
          }
        }
        return null
      }),
      footerText: computed(() => {
        if(state.status === 'completed') return 'watch again';
        if(state.status === 'started') return 'continue';
        return 'watch now'
      }),
      isCompleted: computed(() => state.status === 'completed')
    });

    const toggleBookmark = async () => {
      setItemLoading(true, 'Updating Bookmark');
      await memberProvider().toggleBookmark(state.item.id, state.member.id, !state.isBookmarked, state.member.token, config);
      await collectionsProvider().loadMember(state.member, config, authProvider);
      if(props.reload && props.user) {
        emit('reloadSection', 'My Bookmarks');
      }
      setItemLoading(false, null);
    }


    const toggleArchive = async () => {
      setItemLoading(true, "Updating Archive");
      await memberProvider().toggleArchive(state.item.id, state.member.id, !state.isArchived, state.member.token, config);
      await collectionsProvider().loadMember(state.member, config, authProvider);
      if(props.reload && props.user) {
        emit('reloadSection', 'Completed/Archived Courses');
      }
      setItemLoading(false, null);
    }

    const setItemLoading = (isUpdating, updatingText) => {
      state.item.updatingText = updatingText;
      state.item.isUpdating = isUpdating;
    }

    return {
      state,
      FormattingService,
      toggleBookmark,
      toggleArchive,
    }
  },
  methods: {
    toggleModal(item) {
      this.$emit('toggleModal', item);
    }
  }
}
